'use strict';

import $ from 'jquery';
import 'select2';
import formValidate from '../../modules/formValidate';
import croppieModal from '../../modules/croppieModal';

const ongsCreate = {
  settings: {
    $ongs: $('.js-ong'),
    $selectState: $('.js-state-filter'),
    $selectCity: $('#js-cities'),
    $form: document.querySelector('.js-form-ongs'),
  },

  geoAutocomplete() {
    let interval = setInterval(() => {
      if (typeof google === 'object' && typeof google.maps === 'object' && $('[data-geolocate]').length) {
        initAutocomplete();
      }
    }, 200);

    let autocomplete;

    function initAutocomplete() {
      clearInterval(interval);
      // Create the autocomplete object, restricting the search to geographical
      // location types.
      autocomplete = new google.maps.places.Autocomplete(/** @type {!HTMLInputElement} */ (document.getElementById('autocomplete')), { types: ['geocode'] });
    }

    if ($('[data-geolocate]').length) {
      $('[data-geolocate]').on('focus', geolocate());
    }

    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    function geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy,
          });
          autocomplete.setBounds(circle.getBounds());
        });
      }
    }
  },

  init() {
    croppieModal.init();

    if (s.$form) {
      const formFields = {
        common: ['type', 'name', 'corporate_name', 'cnpj', 'address', 'cep', 'state_id', 'city_id', 'responsible', 'responsible_cpf'],
      };

      s.$form.addEventListener('submit', e => {
        formValidate.validateMask(e, { cnpj: e.target.cnpj, cep: e.target.cep });
        formValidate.init(e, formFields);
      });
    }

    function formatOptions(opt) {
      if (typeof opt.local === 'undefined') {
        var $opt = $('<div class="u-size-16 u-m-b-10">' + opt.text + '</div>');
      } else {
        var $opt = $(`<div class="u-size-16 u-m-b-10"> ${opt.corporate_name ? opt.corporate_name + '</br>' : ''}  ${opt.text}  <br/>  ${opt.local} </div>`);
      }

      return $opt;
    }

    function matchCustom(params, data) {
      // If there are no search terms, return all of the data
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do not display the item if there is no 'text' property
      if (typeof data.text === 'undefined') {
        return null;
      }

      // `params.term` should be the term that is used for searching
      // `data.name, data.email and data.enrollment` is the text that is displayed for the data object
      if (
        (data.text && data.text.toLowerCase().includes(params.term.toLowerCase())) ||
        (data.corporate_name && data.corporate_name.toLowerCase().includes(params.term.toLowerCase())) ||
        (data.local && data.local.toLowerCase().includes(params.term.toLowerCase()))
      ) {
        var modifiedData = $.extend({}, data, true);
        modifiedData.text;

        // You can return modified objects from here
        // This includes matching the `children` how you want in nested data sets
        return modifiedData;
      }

      // Return `null` if the term should not be displayed
      return null;
    }

    fetch(`${window.location.origin}/get/ongs`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('input[name="_token"]').value,
      },
    })
      .then(response => (response.ok ? response.json() : console.log('Network response was not ok.')))
      .then(data => {
        s.$ongs
          .select2({
            theme: 'classic',
            placeholder: 'Selecione a organização',
            data: JSON.parse(data.ongs),
            templateSelection: formatOptions,
            templateResult: formatOptions,
            matcher: matchCustom,
          })
          .on('change', function(e) {
            fetch(`/get/ong/${e.target.value}`, {
              method: 'GET',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('input[name="_token"]').value,
              },
            })
              .then(response => (response.ok ? response.json() : console.log('Network response was not ok.')))
              .then(data => {
                let ongData = $(`<p>
                  ${data.corporate_name ? '<b>Razão social:</b> ' + data.corporate_name + '<br/>' : ''}
                  ${data.name ? '<b>Nome da organização:</b> ' + data.name + '<br/>' : ''}
                  ${data.responsible ? '<b>Nome do representante:</b> ' + data.responsible + '<br/>' : ''}
                  ${data.midia ? '<b>E-mail:</b> ' + data.midia + '<br/>' : ''}
                  ${data.phone ? '<b>Telefone:</b> ' + data.phone + '<br/>' : ''}
                  ${data.address ? '<b>Endereço da organização:</b> ' + data.address + '<br/>' : ''}
                  ${data.cep ? '<b>CEP:</b> ' + data.cep + '<br/>' : ''}
                  ${data.city ? '<b>Cidade:</b> ' + data.city + '<br/>' : ''}
                  ${data.state ? '<b>Estado:</b> ' + data.state : ''}
                </p>`);

                $('.js-ong-data')
                  .empty()
                  .append(ongData);
              });
          });
      })
      .catch(error => {
        console.log('There has been a problem with your fetch operation: ' + error.message);
      });

    $('[name=organization_type]').on('change', function(e) {
      if ($(this).val() === 'new') {
        $('#tab_new_organization').show();
        $('#tab_use_organization').hide();
      } else {
        $('#tab_new_organization').hide();
        $('#tab_use_organization').show();
      }
    });

    s.$selectState
      .select2({
        theme: 'classic',
      })
      .on('change', function(e) {
        var post = {};
        post.id = e.target.value;
        post._token = $('meta[name="csrf-token"]').attr('content');
        var url = '/estados/busca-cidades/' + post.id;

        $.ajax({
          type: 'GET',
          url: url,
          data: post,
          cache: false,
          dataType: 'json',
        }).then(function(data) {
          s.$selectCity.empty();

          $.each(data, function(index, element) {
            var option = new Option(element, index);
            s.$selectCity.append(option);
          });
        });
      });

    s.$selectCity.select2({
      placeholder: 'Primeiro selecione seu estado',
      theme: 'classic',
      sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
    });

    ongsCreate.geoAutocomplete();
  },
};

const s = ongsCreate.settings;

export default ongsCreate;
